module.exports = __webpack_public_path__ + "img/waistband elastic width.202b20a8.png";